export const API_BASE_URL = process.env.REACT_APP_BASE_URL

export const GRAPHQL_BASE_URL = process.env.REACT_APP_GRAPHQL_URL

export const MAX_REQUESTS_COUNT = 1

export const INTERVAL_MS = 10